export type Direction = 'left' | 'right' | 'top' | 'bottom';

export const orthogonalSide = (d: Direction) => {
    switch (d) {
        case 'left':
        case 'right':
            return 'height';
        case 'top':
        case 'bottom':
            return 'width';
    }
};

export const directionX = (from: Direction, amount: number) => {
    switch (from) {
        case 'right':
            return amount;
        case 'left':
            return -amount;
        default:
            return 0;
    }
};

export const directionY = (from: Direction, amount: number) => {
    switch (from) {
        case 'top':
            return -amount;
        case 'bottom':
            return amount;
        default:
            return 0;
    }
};
